export default __webpack_public_path__ + "static/media/MomoBrown.c2958bab.png";